<!-- =========================================================================================
  File Name: bank.vue
  Description: User Bank
========================================================================================== -->

<template>
  <div id="user-bank">

    <vx-card title="会员银行卡">

      <div slot="actions">
        <vx-input-group>
          <template slot="prepend">
            <vs-input class="w-48" v-model="uid" placeholder="用户名 / UID" />
          </template>
          <vs-input class="w-48" v-model="name" placeholder="银行卡姓名" />
          <template slot="append">
            <div class="append-text bg-warning cursor-pointer" @click="search">
              <feather-icon icon="SearchIcon"></feather-icon>
            </div>
          </template>
        </vx-input-group>
      </div>

      <vs-table stripe :data="list" noDataText="暂无银行卡">
        <template slot="thead">
          <vs-th width="120">UID</vs-th>
          <vs-th width="200">用户名</vs-th>
          <vs-th width="250">银行名称</vs-th>
          <vs-th width="250">开户行</vs-th>
          <vs-th width="300">银行卡号</vs-th>
          <vs-th width="200">开户名</vs-th>
          <vs-th>操作</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="index" v-for="(item, index) in list" >
            <vs-td :data="item.id">{{item.uid}}</vs-td>
            <vs-td :data="item.user.username">{{item.user.username}}</vs-td>
            <vs-td :data="item.bank">{{item.bank}}</vs-td>
            <vs-td :data="item.open">{{item.open}}</vs-td>
            <vs-td :data="item.code">{{item.code}}</vs-td>
            <vs-td :data="item.name">{{item.name}}</vs-td>
            <vs-td>
              <vs-button color="primary" type="filled" size="small" @click="modify" :data-index="index">编辑</vs-button>
              <vs-button color="danger" type="border" size="small" @click="del" :data-index="index" class="ml-5">删除</vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <vs-pagination class="mt-6" :total="totalPage" v-model="page" goto />
    </vx-card>

    <!-- 更改侧边栏-->
    <modify-sider-bar ref="modifySiderBar" title="更改银行信息" @confirm="submit">
      <div class="p-4">
        <div class="mb-4">
          <vs-select class="w-full" v-model="modifyItem.icon" label="银行名称">
            <vs-select-item :key="index" :value="index" :text="item" v-for="(item, index) in bankList" />
          </vs-select>
        </div>
        <div class="mb-4">
          <vs-input class="w-full" v-model="modifyItem.bank" label="银行" />
        </div>
        <div class="mb-4">
          <vs-input class="w-full" v-model="modifyItem.open" label="开户行" />
        </div>
        <div class="mb-4">
          <vs-input class="w-full" v-model="modifyItem.code" label="银行卡号" />
        </div>
        <div class="mb-4">
          <vs-input class="w-full" v-model="modifyItem.name" label="开户姓名" />
        </div>
      </div>
    </modify-sider-bar>
  </div>
</template>

<script>

import modifySiderBar from '../../layouts/components/modifySiderBar.vue'

export default {
  data() {
    return {
      uid: '',
      name: '',
      page: 1,
      totalPage: 1,
      list: [],
      modifyIndex: 0,
      modifyItem: {},
      bankList: []
    }
  },
  components: {
    modifySiderBar
  },
  methods: {
    modify (e) {
      this.modifyIndex = e.currentTarget.dataset.index
      this.modifyItem = JSON.parse(JSON.stringify(this.list[parseInt(this.modifyIndex)]))
      this.$refs.modifySiderBar.open()
    },
    submit () {
      const postdata = JSON.parse(JSON.stringify(this.modifyItem))
      postdata.authKey = localStorage.getItem('authKey')
      this.$utils.post('user-bankDo', postdata).then(res => {
        this.$vs.dialog({
          title: '提示',
          text: res,
          acceptText: '确认'
        })
        this.load()
        this.$refs.modifySiderBar.close()
      })
    },
    del (e) {
      const index = e.currentTarget.dataset.index
      const postdata = {}
      postdata.id = this.list[index].id
      postdata.authKey = localStorage.getItem('authKey')
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: '确认',
        text: '确认删除该银行信息吗?',
        acceptText: '确认',
        cancelText: '取消',
        accept: () => {
          this.$utils.post('user-bankDelete', postdata).then(res => {
            this.$vs.dialog({
              title: '提示',
              text: res,
              acceptText: '确认'
            })
            this.list.splice(index, 1)
          })
        }
      })
    },
    search() {
      this.page = 1
      this.load()
    },
    load() {
      const postdata = {}
      postdata.authKey = localStorage.getItem('authKey')
      postdata.uid = this.uid
      postdata.name = this.name
      postdata.page = this.page
      this.$utils.post('user-bankList', postdata).then(res => {
        this.list = res.list
        this.totalPage = Math.ceil(res.count / res.pagesize)
      })
    }
  },
  watch: {
    page(newValue) {
      this.page = newValue
      this.load()
    }
  },
  mounted () {
    this.load()

    // 获取银行卡列表
    this.$utils.post('money-bankList', { authKey: localStorage.getItem('authKey') }).then(res => {
      this.bankList = res
    })
  }
}
</script>
